import React, { Component } from 'react';
import { withStyles } from '@material-ui/core/styles';
import CssBaseline from '@material-ui/core/CssBaseline';
import Paper from '@material-ui/core/Paper';
import Button from '@material-ui/core/Button';
import TextField from '@material-ui/core/TextField';
import Typography from '@material-ui/core/Typography';
import Grid from '@material-ui/core/Grid';
import PropTypes from 'prop-types';
import { withRouter } from 'react-router-dom'
import { green } from '@material-ui/core/colors';
import { AddSocialNetwork, GetSocialNetwork, EditSocialNetwork } from '../../fetchs';

import './socialnetwork.styles.css';

const useStyles = theme => ({
  appBar: {
    position: 'relative',
  },
  layout: {
    width: 'auto',
    marginLeft: theme.spacing(2),
    marginRight: theme.spacing(2),
    [theme.breakpoints.up(600 + theme.spacing(2) * 2)]: {
      width: 600,
      marginLeft: 'auto',
      marginRight: 'auto',
    },
  },
  paper: {
    marginTop: theme.spacing(3),
    marginBottom: theme.spacing(3),
    padding: theme.spacing(2),
    [theme.breakpoints.up(600 + theme.spacing(3) * 2)]: {
      marginTop: theme.spacing(6),
      marginBottom: theme.spacing(6),
      padding: theme.spacing(3),
    },
  },
  stepper: {
    padding: theme.spacing(3, 0, 5),
  },
  buttons: {
    display: 'flex',
    justifyContent: 'flex-end',
  },
  button: {
    marginTop: theme.spacing(3),
    marginLeft: theme.spacing(1),
  },
  container: {
    width: 600,
    display: 'flex',
    flexWrap: 'wrap',
  },
  buttonProgress: {
    color: green[500],
    position: 'relative',
    top: '50%',
    left: '50%',
    marginTop: -12,
    marginLeft: -12
  },
});

class SocialNetwork extends Component {
  constructor(props) {
    super(props);

    this.state = {
      name: '',
      address: '',
      logo: '',
      loading: false,
      saving: false,
    }
  }

  componentDidMount() {
    const socialNetworkId = this.props.match.params.socialNetworkId;
    if (socialNetworkId) {
      this.loadSocialNetwork(socialNetworkId);
    }
  }

  loadSocialNetwork = (socialNetworkId) => {
    this.setState({ loading: true });
    GetSocialNetwork(socialNetworkId)
      .then(response => {
        this.setState({ loading: false });
        return response.json();
      })
      .then(responseJson => {
        this.setState({
          socialNetworkId: responseJson.socialNetworkId,
          name: responseJson.name,
          address: responseJson.address,
          logo: responseJson.logo
        });
      })
      .catch(error => {
        this.setState({ loading: false });
        console.log(error);
      });
  }

  handleSave = () => {
    if (this.props.match.params.socialNetworkId) {
      EditSocialNetwork(this.state.socialNetworkId, {
        name: this.state.name,
        address: this.state.address,
        logo: this.state.logo
      }).then(response => {
        if (response.status === 400) {
          console.log(response);
        } else if (response.status === 200) {
          this.props.history.push('/main/socialnetworks');
        }
        return response.json();
      }).then(responseJson => {
        console.log(responseJson.message);
      }).catch(error => {
        console.error(error);
      });
    } else {
      AddSocialNetwork({
        name: this.state.name,
        address: this.state.address,
        logo: this.state.logo
      }).then(response => {
        if (response.status === 400) {
          console.log(response);
        } else if (response.status === 200) {
          this.props.history.push('/main/socialnetworks');
        }
        return response.json();
      }).then(responseJson => {
        console.log(responseJson.message);
      }).catch(error => {
        console.error(error);
      });
    }
  };

  handleChange = name => event => {
    this.setState({ [name]: event.target.value });
  }

  render() {
    const { classes } = this.props;
    return (
      <React.Fragment>
        <CssBaseline />
        <main className={classes.layout}>
          <Paper className={classes.paper}>
            <Typography component="h1" variant="h4" align="center">
              افزودن شبکه اجتماعی جدید
            </Typography>
            <Grid container>
              <form className={classes.container} noValidate autoComplete="off">
                <Grid container spacing={3}>
                  <Grid item xs={12} sm={6}>
                    <TextField
                      id="standard-name"
                      label="نام"
                      required
                      fullWidth
                      className={classes.textField}
                      value={this.state.name}
                      onChange={this.handleChange('name')}
                      margin="normal"
                    />
                  </Grid>
                  <Grid item xs={12} sm={6}>
                    <TextField
                      id="standard-logo"
                      label="لوگو"
                      required
                      fullWidth
                      className={classes.textField}
                      value={this.state.logo}
                      onChange={this.handleChange('logo')}
                      margin="normal"
                    />
                  </Grid>
                  <Grid item xs={12}>
                    <TextField
                      id="standard-address"
                      label="آدرس"
                      required
                      fullWidth
                      className={classes.textField}
                      value={this.state.address}
                      onChange={this.handleChange('address')}
                      margin="normal"
                    />
                  </Grid>
                  <Grid item xs={12}>
                    <Button
                      variant="contained"
                      color="primary"
                      fullWidth
                      disabled={this.state.loading}
                      onClick={this.handleSave}>ذخیره</Button>
                  </Grid>
                </Grid>
              </form>
            </Grid>
          </Paper>
        </main>
      </React.Fragment>
    )
  };
}

SocialNetwork.propTypes = {
  classes: PropTypes.object.isRequired,
};

export default withRouter(withStyles(useStyles)(SocialNetwork));
